// removed by extract-text-webpack-plugin
module.exports = {"sm":"only screen and (min-width: 48em)","md":"only screen and (min-width: 64em)","lg":"only screen and (min-width: 75em)","goalsHeaderContainer":"goalsHeaderContainer-2yEhw","mainTitle":"mainTitle-1J-SQ","subTitle":"subTitle-1LPl7","createLink":"createLink-K8HWH","createGoalButton":"createGoalButton-106x8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/goals/shared/_goalsHeader.css
// module id = 1201
// module chunks = 1